import React from 'react';
import withStyles from "isomorphic-style-loader/withStyles";
import s from './Skeleton.css';
import cx from 'classnames';

const Shimmer = ({ skeletonRelative }) => {
    return (
        <div className={cx(s.shimmerWrapper, skeletonRelative, 'kindTripBorder', 'newsBoxBorder', 'newsBoxDarkAfter')}>
            <div className={s.shimmer}></div>
        </div>
    )
}

export default withStyles(s)(Shimmer);